import { Flex } from "antd";
import { HintsType } from "interfaces/tooltipSettings";
import { observer } from "mobx-react-lite";
import { AddTemplatesFileBtn } from "../DocumentTemplates/TemplatesBlock/AddTemplatesFileBtn";

import styles from "./hintsManagement.module.css";
import { useStores } from "stores";
import { downloadFileBlob, requestWithNotify, useRequestWithNotify } from "utils";
import { ENDPOINTS, uploadTooltipsFile } from "services";
import { useNotificationContext } from "providers";
import { useCallback, useMemo, useState } from "react";
import { DropdownButton } from "ui";

export const ColumnBtnBlock = observer(({ status }: { status: HintsType["objectStatus"] }) => {
  const { hintsManagement } = useStores();

  const { request, loading } = useRequestWithNotify({
    errorMsg: "Ошибка при скачивании шаблона",
    showErrorNotification: true,
  });

  const uploadFile = async (file: File, status: string) => {
    const formData = new FormData();
    formData.append("file", file);

    return request(() => uploadTooltipsFile({ status, formData }));
  };

  const items = [
    {
      key: "default",
      label: "Скачать эталон",
      onClick: () => request(() => downloadFileBlob(ENDPOINTS.downloadDefaultDocTooltips(status), true)),
    },
    {
      key: "rules",
      label: "Скачать текущую версию",
      onClick: () => request(() => downloadFileBlob(ENDPOINTS.downloadDocTooltipsRules(status), true)),
    },
  ];

  return (
    <Flex justify="end" gap="4px">
      <AddTemplatesFileBtn
        fn={({ file }) => uploadFile(file, status)}
        tooltip="Загрузить документ"
        className={styles.uploadDocBtn}
        successMessage="Документ успешно обновлен"
        onSuccess={hintsManagement.fetch}
        loading={loading}
        disabled={loading}
      />
      <DropdownButton className={styles.uploadDocBtn} items={items} disabled={loading} loading={loading} />
    </Flex>
  );
});
